import { render, staticRenderFns } from "./PricingDetails.vue?vue&type=template&id=2e52c548&scoped=true&"
import script from "./PricingDetails.vue?vue&type=script&lang=js&"
export * from "./PricingDetails.vue?vue&type=script&lang=js&"
import style0 from "./PricingDetails.vue?vue&type=style&index=0&id=2e52c548&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e52c548",
  null
  
)

export default component.exports